import { api, clearTokenTimer } from './baseAPI';
import { ApiResponse } from '../types/api';

// 인증 관련 API
export const authAPI = {
  // 통합 로그인 (사용자/선생님 자동 구분)
  login: async (credentials: { loginId: string; password: string }): Promise<ApiResponse<any>> => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  // 액세스 토큰 재발급
  refreshToken: async (): Promise<ApiResponse<any>> => {
    const response = await api.post('/auth/refresh');
    return response.data;
  },

  // 로그아웃
  logout: async (): Promise<ApiResponse<void>> => {
    try {
      const response = await api.post('/auth/logout');
      // 로그아웃 성공 시 토큰 타이머 정리
      clearTokenTimer();
      return response.data;
    } catch (error) {
      // 로그아웃 실패해도 타이머는 정리
      clearTokenTimer();
      throw error;
    }
  },

  // 통합 토큰 검증 (사용자/선생님 자동 구분)
  verifyToken: async (): Promise<ApiResponse<any>> => {
    const response = await api.get('/auth/verify');
    return response.data;
  },
};

export default authAPI;